import styled from '@emotion/styled';

export const ListItem = styled.li`
  display: flex;
  background-color: var(--white);
  border: 1px solid var(--border1);
  padding: 12px 16px;
  border-top: 0;
  gap: 8px;

  &:first-of-type {
    border-top: 1px solid var(--border1);
    border-radius: 8px 8px 0 0;
  }
`;

export const LeftContainer = styled.div`
  flex: 1;
`;

export const RightContainer = styled.div`
  //   min-width: 30%;
`;
